import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../Layout";
import { Dashboard, Logout, Tutorial } from "../Pages";
import Profile from "Pages/Profile";
import File from "Pages/File";
import AddFile from "Pages/File/AddFile";

const Router = () => {
  return (
    <Routes>
      {/* Redirect root to /fa */}
      <Route path="/" element={<Navigate to="/fa" replace />} />

      {/* All routes with language prefix */}
      <Route path=":lang/*" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="file/addfile" element={<AddFile />} />
        <Route path="tutorial" element={<Tutorial />} />
        <Route path="profile" element={<Profile />} />
        <Route path="file" element={<File />} />
        <Route path="file/addfile/:fileId" element={<AddFile />} />
        <Route path="admin/logOut" element={<Logout />} />
        <Route path="*" element={<Navigate to="/fa" replace />} />
      </Route>
    </Routes>
  );
};

export default Router;
